module.exports = __webpack_public_path__ + "img/pe.628c6689.svg";